// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://ttguzgouurqopeccvzve.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InR0Z3V6Z291dXJxb3BlY2N2enZlIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDgyMDI1NzEsImV4cCI6MjA2Mzc3ODU3MX0.JrJbtkh8MUA5DA5v2MSPHfb2pRaz08fU-HibNYVTHwE";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);